/**
 * Error Monitoring Service (Sentry)
 *
 * Captures uncaught errors and performance data in production.
 * No-ops in development or when REACT_APP_SENTRY_DSN is unset.
 */

import * as Sentry from '@sentry/react';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const isDevelopment = process.env.NODE_ENV === 'development';

export const initMonitoring = () => {
  if (!SENTRY_DSN || isDevelopment) {
    return;
  }

  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.NODE_ENV,
      tracesSampleRate: 0.1,
    });
    console.log('[Monitoring] Sentry initialized');
  } catch (error) {
    console.error('[Monitoring] Failed to initialize Sentry:', error);
  }
};
